import React from 'react'
import {
  IconButton,
  Badge,
  Button,
  Stack,
} from '@mui/material'
import TuneIcon from '@mui/icons-material/Tune'
import ClearIcon from '@mui/icons-material/Clear'

export interface FilterBarProps {
  activeFilterKeys: string[]
  onOpenFilters: () => void
  onClearFilters: () => void
}

export const FilterBar: React.FC<FilterBarProps> = ({
  activeFilterKeys,
  onOpenFilters,
  onClearFilters,
}) => {
  const hasFilters = activeFilterKeys.length > 0

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
      sx={{ px: 1, py: 0.5 }}
    >
      <IconButton onClick={onOpenFilters} size="small">
        <Badge
          badgeContent={hasFilters ? activeFilterKeys.length : undefined}
          color="primary"
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.65rem',
              height: '18px',
              minWidth: '18px',
            },
          }}
        >
          <TuneIcon fontSize="small" />
        </Badge>
      </IconButton>

      {hasFilters && (
        <Button
          size="small"
          variant="outlined"
          onClick={onClearFilters}
          startIcon={<ClearIcon fontSize="small" />}
          sx={{
            fontSize: '0.75rem',
            height: 32,
            borderRadius: '16px',
            px: 1.5,
            textTransform: 'none',
          }}
        >
          Limpar filtros
        </Button>
      )}
    </Stack>
  )
}
